import { render } from "./AgreementView.vue?vue&type=template&id=d44fe02a&scoped=true"
const script = {}

import "./AgreementView.vue?vue&type=style&index=0&id=d44fe02a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d44fe02a"]])

export default __exports__